import {
    CellDetailsByCountryTooltip,
    type CellDetailsByCountryTooltipProps,
} from "app/pages/sales-intelligence/common-components/table-cells";

import type { EnrichedLeadsSearchRow } from "../../../types";

type Props<R extends EnrichedLeadsSearchRow> = Omit<CellDetailsByCountryTooltipProps, "data"> & {
    dataIndex: keyof R;
    record: R;
};

const LeadsDetailsByCountryTooltip = <R extends EnrichedLeadsSearchRow>({
    children,
    formatFn,
    dataIndex,
    record,
}: Props<R>) => {
    const dataIndexDetailedResult = record.detailedData?.[dataIndex as keyof typeof record.detailedData];

    if (!dataIndexDetailedResult) {
        return children;
    }

    return (
        <CellDetailsByCountryTooltip
            data={dataIndexDetailedResult}
            formatFn={formatFn}
        >
            {children}
        </CellDetailsByCountryTooltip>
    );
};

export default LeadsDetailsByCountryTooltip;
